module.exports = __webpack_public_path__ + "assets/70e9036c57afc92fef6bd05831e7f8d4.mp3";